import React from "react";
import { observer, inject } from "mobx-react";
import "./ShareLink.scss";
import ShareLinkStore from "./ShareLinkStore";
import { deserializeQuery, translateShareLinkToRoute } from "./ShareLinkUtils";
import Widget from "../Widget";
import Loader from "../../shared/Loader/Loader";
import authStore from "../../authStore";
import * as _ from "lodash";

class ShareLink extends Widget {
  constructor(props) {
    super(props);
    this.store = new ShareLinkStore();
    const loggedIn = Boolean(authStore.authToken);

    if (_.get(deserializeQuery({ query: props.location.search }), "payload")) {
      sessionStorage.clear();
      this.store.decryptShareLink(props.location).then((route) => {
        window.location.hash = `#${route}`;
        props.history.push(route);
        this.logLinkLaunch("c3p0LinkLaunch");
      });
    } else {
      props.history.push(
        translateShareLinkToRoute({
          url:
            props.location.pathname.replace(
              /^.*\/sharelink\//,
              "airstripone://",
            ) + props.location.search,
        }),
      );
      if (loggedIn) {
        this.logLinkLaunch("shareLinkLaunch");
      }
    }
  }

  logLinkLaunch = (operationType) => {
    this.store.postOpsLog({
      operationType,
      context: window.location.href,
      extraContext: {
        referrer: document.referrer,
      },
    });
  };
  render() {
    return (
      <div className="share-link widget">
        {this.store.loading ? (
          <div className="decrypting">
            <h2>Decrypting Share-Link ...</h2>
            <Loader />
          </div>
        ) : null}
      </div>
    );
  }
}

export default inject("store")(observer(ShareLink));
